var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * StarHalf component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconStarHalf extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.4498 1.45145C17.5898 1.59145 17.6698 1.78145 17.6698 1.98145L17.6898 19.2314C17.6898 19.6614 16.8298 20.1414 16.8898 20.1114C16.9498 20.0714 16.8898 20.1114 16.8898 20.1114L11.8998 22.8214C11.8998 22.8214 11.8798 22.8214 11.8698 22.8314C11.5998 22.9614 11.2998 23.0214 10.9998 22.9914C10.6998 22.9614 10.4098 22.8514 10.1698 22.6714C9.92978 22.4914 9.73978 22.2514 9.62978 21.9714C9.51978 21.6914 9.48978 21.3914 9.53978 21.0914L10.5398 15.3214C10.5398 15.3014 10.5398 15.2714 10.5398 15.2514C10.5398 15.2314 10.5198 15.2114 10.4998 15.1914L6.51978 11.1014C6.29978 10.8914 6.13978 10.6314 6.05978 10.3414C5.97978 10.0414 5.97978 9.72145 6.06978 9.43145C6.15978 9.13145 6.32978 8.87145 6.55978 8.66145C6.78978 8.45145 7.07978 8.32145 7.38978 8.27145H7.39978L12.9298 7.47145C12.9398 7.47145 12.9498 7.47145 12.9598 7.46145C12.9598 7.46145 12.9798 7.45145 12.9798 7.44145C12.9798 7.44145 12.9798 7.42145 12.9898 7.42145L15.4798 2.17145C15.5998 1.89145 15.8098 1.66145 16.0598 1.49145C16.3098 1.32145 16.6098 1.23145 16.9198 1.23145C17.1198 1.23145 17.3098 1.31145 17.4498 1.45145ZM16.1698 4.20145L14.3498 8.04145C14.2398 8.28145 14.0798 8.49145 13.8598 8.65145C13.6498 8.81145 13.3898 8.92145 13.1298 8.95145L7.61978 9.74145C7.61978 9.74145 7.56978 9.76145 7.54978 9.78145C7.52978 9.80145 7.50978 9.82145 7.49978 9.85145C7.49978 9.88145 7.49978 9.91145 7.49978 9.94145C7.49978 9.97145 7.51978 9.99145 7.53978 10.0114C7.54978 10.0114 7.55978 10.0314 7.56978 10.0414L11.5598 14.1414C11.7398 14.3214 11.8798 14.5514 11.9598 14.8014C12.0398 15.0514 12.0598 15.3114 12.0198 15.5714L11.0198 21.3514C11.0198 21.3514 11.0198 21.4014 11.0198 21.4214C11.0198 21.4414 11.0398 21.4614 11.0598 21.4714C11.0798 21.4814 11.0998 21.4914 11.1198 21.4914C11.1398 21.4914 11.1598 21.4914 11.1798 21.4914L16.1598 18.7814C16.1598 18.7814 16.1598 18.7814 16.1698 18.7814V4.20145Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconStarHalf.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconStarHalf.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconStarHalf.prototype, "size", void 0);
if (customElements.get('cat-icon-star-half') === undefined) {
    customElements.define('cat-icon-star-half', BlocksIconStarHalf);
}
